import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { cn } from "@util/helpers";

type HomepageLifestyleStoriesProps = {
  /** The props needed for the card. */
  cardProps: ComponentProps<typeof Card>;
};

const HomepageLifestyleStories = ({
  cardProps,
}: HomepageLifestyleStoriesProps): React.ReactElement => {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const isSubscriber = OKTAUserInfo?.usertype === OKTAUserTypeEnum.SUBSCRIBER;

  const variant: CardVariations = {
    image: {
      position: "left",
      width: "w-120px lg:w-1/3",
      aspectRatio: "aspect-3x2",
      imageClassName: "object-cover",
      orientation: "landscape",
      filters: {
        breakpoint: "(min-width: 1200px)",
        w: 252,
        h: 168,
        dpr: 1,
        f: "webp",
      },
      // [ { breakpoint: "(min-width: 992px)", w: 204, h: 136, dpr: 1, f: "webp" }, { w: 240, h: 160, dpr: 1, f: "webp" }, ],
    },
    content: {
      width: "w-full-120px lg:w-2/3",
      extraClass: "pl-4 text-white",
      updatedTimeColor: "!text-white",
    },
    title: {
      color: "text-white",
      size: "text-base",
      extraClass: "font-lct font-bold",
    },
    kicker: {
      color: "text-gray-515",
      extraClass: "break-words font-poppins text-4xs font-light leading-4",
    },
    section: { extraClass: cn("[&>a:hover>span]:underline") },
  };

  return (
    <div className="story py-3">
      <Card
        {...cardProps}
        variations={variant}
        displayPaywall={isSubscriber && cardProps.displayPaywall}
      />
    </div>
  );
};

export default HomepageLifestyleStories;
